'use client';

import { faArrowAltCircleLeft } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';

import { clickVisitCategoryPageLink } from '@/utils/analytics/log-event';

type Props = {
  categorySlug: string;
};

const Component: React.FC<Props> = ({ categorySlug }) => {
  return (
    <Link
      prefetch={false}
      href={`/blogs/${categorySlug}`}
      onClick={() =>
        clickVisitCategoryPageLink('blog_list_page_return_link', categorySlug)
      }
      className="flex items-center justify-center text-base hover:text-gray-500 active:text-gray-600"
    >
      <FontAwesomeIcon
        fixedWidth
        className="mr-1"
        icon={faArrowAltCircleLeft}
      />
      ブログ記事一覧に戻る
    </Link>
  );
};

export default Component;
